import ProcessingResult from "../../framework/ProcessingResult";

import CustomerAgentApi from "../../api/CustomerAgentApi";

import CreateOrUpdateCustomerAgentResult from "../../classes/api/result/customeragentmodule/CreateOrUpdateCustomerAgentResult";

export default class AgentCrudLogic {

    CreateOrUpdateAgentAsync = async (id: number | null, name: string, roles: number): Promise<ProcessingResult<CreateOrUpdateCustomerAgentResult>> => {

        if (id === null) {
            let createAgentResult = await CustomerAgentApi.CreateCustomerAgentAsync(name, roles);
            if (createAgentResult.IsFailed()) {
                return ProcessingResult.Error("Error in CreateCustomerAgentAsync " + createAgentResult.ErrorMessage);
            }

            return createAgentResult;
        }

        let updateAgentResult = await CustomerAgentApi.UpdateCustomerAgentAsync(id, name, roles);
        if (updateAgentResult.IsFailed()) {
            return ProcessingResult.Error("Error in UpdateCustomerAgentAsync " + updateAgentResult.ErrorMessage);
        }

        return updateAgentResult;
    }
}